import React from "react";
import { renderRoutes } from "react-router-config"
import { Redirect } from "react-router-dom";

import { saveAuthToken } from "apiCommandsExecutor/token";
import { useSession } from "shared/hooks/useSession";
import useQuery from "hooks/useQuery";


const SecurityLayout = (props: any) => {
    const { authToken } = useQuery<{ authToken?: string }>();

    /*
    * Вход по ссылке (?authToken=... из письма о регистрации) — токен кладём до первой
    * загрузки сессии, синхронно на рендере: useSession стартует запрос в своём эффекте,
    * и в эффекте лейаута мы бы уже опоздали.
    * */
    if (authToken) {
        saveAuthToken(authToken);
    }

    const { account, loading } = useSession();

    if (loading) return null;

    if (!account) {
        return <Redirect to={"/auth/sign-in"}/>
    }

    //@ts-ignore
    const route = props.route || {};

    if (window.location.hash === '#'
        || window.location.hash === '#/'
        || window.location.pathname === "/") {
        return <Redirect to={"/menus/regular/list"}/>
    }

    return renderRoutes(route.routes);
};


export default SecurityLayout;
